(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["varel-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeReviewCarousels = (root = document) => {
      root.querySelectorAll('[data-review-carousel]').forEach((carousel) => {
        if (carousel.dataset.initialized === 'true') return;

        const viewport = carousel.querySelector('[data-review-viewport]');
        const track = carousel.querySelector('.varel-reviews__track');
        const cards = Array.from(carousel.querySelectorAll('[data-review-card]'));
        const previousButton = carousel.querySelector('[data-review-prev]');
        const nextButton = carousel.querySelector('[data-review-next]');
        const currentLabel = carousel.querySelector('[data-review-current]');
        const totalLabel = carousel.querySelector('[data-review-total]');

        if (!viewport || !track || !cards.length || !previousButton || !nextButton) return;

        carousel.dataset.initialized = 'true';
        let currentPage = 0;
        let scrollFrame;

        const getGap = () => Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        const getPerPage = () => {
          const cardWidth = cards[0].getBoundingClientRect().width;
          if (!cardWidth) return 1;
          return Math.max(1, Math.round((viewport.clientWidth + getGap()) / (cardWidth + getGap())));
        };
        const getPageCount = () => Math.max(1, Math.ceil(cards.length / getPerPage()));

        const updateControls = () => {
          const pageCount = getPageCount();
          currentPage = Math.min(currentPage, pageCount - 1);
          currentLabel.textContent = String(currentPage + 1);
          totalLabel.textContent = String(pageCount);
          previousButton.disabled = currentPage === 0;
          nextButton.disabled = currentPage === pageCount - 1;
        };

        const goToPage = (page) => {
          const pageCount = getPageCount();
          currentPage = Math.max(0, Math.min(page, pageCount - 1));
          const cardIndex = Math.min(currentPage * getPerPage(), cards.length - 1);
          viewport.scrollTo({ left: cards[cardIndex].offsetLeft, behavior: 'smooth' });
          updateControls();
        };

        const updatePageFromScroll = () => {
          const step = cards[0].getBoundingClientRect().width + getGap();
          if (!step) return;
          const firstVisibleCard = Math.round(viewport.scrollLeft / step);
          currentPage = Math.min(
            Math.round(firstVisibleCard / getPerPage()),
            getPageCount() - 1
          );
          updateControls();
        };

        previousButton.addEventListener('click', () => goToPage(currentPage - 1));
        nextButton.addEventListener('click', () => goToPage(currentPage + 1));
        viewport.addEventListener('scroll', () => {
          cancelAnimationFrame(scrollFrame);
          scrollFrame = requestAnimationFrame(updatePageFromScroll);
        }, { passive: true });

        if ('ResizeObserver' in window) {
          new ResizeObserver(updateControls).observe(viewport);
        }

        updateControls();
      });
    };

    const start = () => initializeReviewCarousels();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeReviewCarousels(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
